import mapFunction from './mapResources';

export default mapFunction('certification_types', {
    isFetching: false,
    items: [] 
});